@if (loggedUser) {
  <mat-toolbar class="primary">
    <ng-template #dropdownItemLabel let-item>
      @let badge = badgeView(item) | async;
      <span class="adx-dropdown-item-row">
        <span>
          @if (item.label) {
            <span>{{ item.label }}</span>
          } @else if (item.pluginModule) {
            <span>
              {{
                item.pluginName + "." + item.pluginModule + "." + item.nameIdentifier
                  | translate
              }}
            </span>
          } @else {
            <span>{{ item.pluginName + "." + item.nameIdentifier | translate }}</span>
          }
          <ng-container *ngTemplateOutlet="badgeStatus; context: { $implicit: badge }"></ng-container>
        </span>
        <ng-container *ngTemplateOutlet="itemBadge; context: { $implicit: badge }"></ng-container>
      </span>
    </ng-template>
    <!-- badge next to a toolbar icon -->
    <ng-template #toolbarBadge let-badge>
      @if (badge) {
        <span class="adx-toolbar-badge" [class.adx-badge-warning]="badge.tone === 'warning'">{{ badge.text }}</span>
      }
    </ng-template>
    <!-- badge of a row in a menu panel, and its status line under the label (see MenuBadgeView) -->
    <ng-template #itemBadge let-badge>
      @if (badge) {
        <span class="adx-item-badge" [class.adx-badge-warning]="badge.tone === 'warning'">{{ badge.text }}</span>
      }
    </ng-template>
    <ng-template #badgeStatus let-badge>
      @if (badge?.message) {
        <span
          class="adx-item-status"
          [class.adx-item-status-warning]="badge.tone === 'warning'"
          [class.adx-item-status-critical]="badge.tone === 'critical'"
          >{{ badge.message }}</span
        >
      }
    </ng-template>
    <div class="adx-title-block">
      <span class="adx-title">{{ appName }}</span>
      <!-- Active dashboard name. The live region is rendered unconditionally so a
           later dashboard switch is announced instead of only being read once. -->
      <span class="adx-subtitle" aria-live="polite">
        @if (currentDashboard) {
          <span class="adx-visually-hidden"
            >{{ "APP.ACTIVE_DASHBOARD" | translate }}: </span
          ><span [title]="currentDashboard.name">{{
            currentDashboard.name
          }}</span>
        }
      </span>
    </div>
    <span class="adx-toolbar-spacer"></span>
    <!-- Primary Menu Start-->
    @for (
      menu of pluginInjectorService.getMenu().primary;
      track menu.nameIdentifier;
      let index = $index
    ) {
      @if (hasMenuAccess(menu) && !isMobileView && (menu.visible$ === undefined || (menu.visible$ | async))) {
        @let badge = badgeView(menu) | async;
        @if (menu.dropdown) {
          <span class="adx-badge-host" animate.enter="adx-fade-in">
            <button
              mat-icon-button
              class="adx-menu-icon adx-caret-icon-button"
              [matMenuTriggerFor]="popup"
              appHoverMenuTrigger
              [matTooltip]="getMenuAriaLabel(menu)"
              [attr.aria-label]="menuTriggerAriaLabel(menu, badge)"
            >
              @if (menu.iconLayers) {
                <fa-layers class="adx-menu-icon">
                  @for (layer of menu.iconLayers; track layer) {
                    <fa-icon
                      [icon]="layer.icon"
                      [transform]="layer.transform ?? ''"
                    >
                    </fa-icon>
                  }
                </fa-layers>
              } @else {
                @if (menu.icon) {
                  <fa-icon [icon]="menu.icon"></fa-icon>
                }
              }
              @if (menu.icon || menu.iconLayers) {
                <fa-icon
                  class="adx-caret-icon"
                  [icon]="'caret-down'"
                  [size]="'xs'"
                ></fa-icon>
              }
            </button>
            <ng-container *ngTemplateOutlet="toolbarBadge; context: { $implicit: badge }"></ng-container>
          </span>
          <!-- second level nested Menu-->
          <mat-menu #popup="matMenu">
            @for (item of menu.dropdownItems; track item.nameIdentifier) {
              @if (item.customPanel === 'dashboard-select') {
                <lib-dashboard-select-menu [showSeparator]="hasDropdownActionsBelowPanel(menu)"></lib-dashboard-select-menu>
              } @else if (canAccessDropdownMenu(menu, item) && (item.visible$ | async) !== false) {
                @if (item.class) {
                  <span>
                    <div>
                      <button
                        mat-menu-item
                        [class]="
                          (item.selected
                            ? item.selected()
                              ? 'selected'
                              : ''
                            : '') + ' adx-theme-selector-option'
                        "
                        (click)="triggerMenuCallback(item, index, menu)"
                      >
                        <span class="adx-tso-row">
                          <span>
                            <div class="adx-center adx-radio">
                              <div class="adx-dot"></div>
                            </div>
                          </span>
                          @if (item.pluginModule) {
                            <span class="adx-tso-row adx-spread">
                              <div class="adx-tso-row">
                                {{
                                  item.pluginName +
                                    "." +
                                    item.pluginModule +
                                    "." +
                                    item.nameIdentifier | translate
                                }}
                              </div>
                              <div class="adx-tso-row {{ item.class }}">
                                <div class="adx-ex-primary"></div>
                                <div class="adx-ex-secondary"></div>
                                <div class="adx-ex-surface"></div>
                              </div>
                            </span>
                          }
                          @if (!item.pluginModule) {
                            <span class="adx-tso-row adx-spread">
                              <div class="adx-tso-row">
                                {{
                                  item.pluginName + "." + item.nameIdentifier
                                    | translate
                                }}
                              </div>
                              <div class="adx-tso-row {{ item.class }}">
                                <div class="adx-ex-primary"></div>
                                <div class="adx-ex-secondary"></div>
                                <div class="adx-ex-surface"></div>
                              </div>
                            </span>
                          }
                        </span>
                      </button>
                    </div>
                  </span>
                } @else {
                  <span>
                    <button
                      mat-menu-item
                      (click)="triggerMenuCallback(item, index, menu)"
                      [disabled]="item.disabled | async"
                    >
                      <ng-container *ngTemplateOutlet="dropdownItemLabel; context: { $implicit: item }"></ng-container>
                    </button>
                  </span>
                }
              }
            }
          </mat-menu>
        } @else {
          <span class="adx-badge-host" animate.enter="adx-fade-in">
            <button
              mat-icon-button
              (click)="triggerMenuCallback(menu, index)"
              [disabled]="menu.disabled | async"
              [matTooltip]="getMenuAriaLabel(menu)"
              [attr.aria-label]="menuTriggerAriaLabel(menu, badge)"
            >
              @if (getAltIcon(menu)) {
                @if (menu.altIcon) {
                  <fa-icon class="adx-menu-icon" [icon]="menu.altIcon"></fa-icon>
                }
              } @else {
                @if (menu.iconLayers) {
                  <fa-layers class="adx-menu-icon">
                    @for (layer of menu.iconLayers; track layer) {
                      <fa-icon
                        [icon]="layer.icon"
                        [transform]="layer.transform ?? ''"
                      >
                      </fa-icon>
                    }
                  </fa-layers>
                } @else {
                  @if (menu.icon) {
                    <fa-icon class="adx-menu-icon" [icon]="menu.icon"></fa-icon>
                  }
                }
              }
            </button>
            <ng-container *ngTemplateOutlet="toolbarBadge; context: { $implicit: badge }"></ng-container>
          </span>
        }
      }
    }
    <!-- Primary Menu Stop -->
    @if (isMobileView) {
      <span class="adx-badge-host adx-hamburger-host" animate.enter="adx-fade-in">
        <a
          class="bold"
          [matMenuTriggerFor]="navMenu"
          aria-label="menu"
        >
          <fa-icon [icon]="'bars'"></fa-icon>
        </a>
        @if (hamburgerBadge$ | async; as badge) {
          <span class="adx-toolbar-badge adx-hamburger-badge" [class.adx-badge-warning]="badge.tone === 'warning'">{{
            badge.text
          }}</span>
        }
      </span>
    } @else {
      <!-- Secondary Menu Start -->
      <a
        class="adx-button bold"
        animate.enter="adx-fade-in"
        aria-label="username"
        [matMenuTriggerFor]="navMenu"
        appHoverMenuTrigger
      >
        {{ loggedUser.name }}
        <fa-icon
          class="adx-menu-icon"
          [icon]="'caret-down'"
          [size]="'xs'"
        ></fa-icon>
      </a>
      <core-plugin-lib-user-avatar
        animate.enter="adx-fade-in"
        [email]="loggedUser.email"
        [name]="loggedUser.name"
        [size]="40"
      >
      </core-plugin-lib-user-avatar>
    }
    <mat-menu
      #navMenu="matMenu"
      (menuOpened)="onMainMenuOpened()"
      xPosition="before"
      class="app-navbar-dropdown"
    >
      @if (isMobileView) {
      <!-- Primary items folded into hamburger on mobile -->
      @for (
        menu of pluginInjectorService.getMenu().primary;
        track menu.nameIdentifier;
        let index = $index
      ) {
        @if (hasMenuAccess(menu) && (menu.visible$ === undefined || (menu.visible$ | async))) {
          @let badge = badgeView(menu) | async;
          @if (menu.dropdown) {
            <button mat-menu-item [matMenuTriggerFor]="popupMobilePrimary">
              <span class="adx-dropdown-item-row">
                <span>
                  @if (menu.icon) {
                    <fa-icon class="adx-menu-icon" [icon]="menu.icon"></fa-icon>
                  }
                  @if (menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName +
                          "." +
                          menu.pluginModule +
                          "." +
                          menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                  @if (!menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName + "." + menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                  <ng-container *ngTemplateOutlet="badgeStatus; context: { $implicit: badge }"></ng-container>
                </span>
                <ng-container *ngTemplateOutlet="itemBadge; context: { $implicit: badge }"></ng-container>
              </span>
            </button>
            <mat-menu #popupMobilePrimary="matMenu">
              @for (item of menu.dropdownItems; track item.nameIdentifier) {
                @if (item.customPanel === 'dashboard-select') {
                  <lib-dashboard-select-menu [showSeparator]="hasDropdownActionsBelowPanel(menu)"></lib-dashboard-select-menu>
                } @else if (canAccessDropdownMenu(menu, item) && (item.visible$ | async) !== false) {
                  <button
                    mat-menu-item
                    (click)="triggerMenuCallback(item, index, menu)"
                    [disabled]="item.disabled | async"
                  >
                    <ng-container *ngTemplateOutlet="dropdownItemLabel; context: { $implicit: item }"></ng-container>
                  </button>
                }
              }
            </mat-menu>
          } @else {
            <button
              mat-menu-item
              (click)="triggerMenuCallback(menu, index)"
              [disabled]="menu.disabled | async"
            >
              <span class="adx-dropdown-item-row">
                <span>
                  @if (menu.iconLayers) {
                    <fa-layers class="adx-menu-icon">
                      @for (layer of menu.iconLayers; track layer) {
                        <fa-icon
                          [icon]="layer.icon"
                          [transform]="layer.transform ?? ''"
                        >
                        </fa-icon>
                      }
                    </fa-layers>
                  } @else {
                    @if (menu.icon) {
                      <fa-icon class="adx-menu-icon" [icon]="menu.icon"></fa-icon>
                    }
                  }
                  @if (menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName +
                          "." +
                          menu.pluginModule +
                          "." +
                          menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                  @if (!menu.pluginModule) {
                    <span>
                      {{ menu.pluginName + "." + menu.nameIdentifier | translate }}
                    </span>
                  }
                  <ng-container *ngTemplateOutlet="badgeStatus; context: { $implicit: badge }"></ng-container>
                </span>
                <ng-container *ngTemplateOutlet="itemBadge; context: { $implicit: badge }"></ng-container>
              </span>
            </button>
          }
        }
      }
      }
      <!-- Secondary items -->
      @for (
        menu of pluginInjectorService.getMenu().secondary;
        track menu.nameIdentifier;
        let index = $index
      ) {
        @if (hasMenuAccess(menu) && (menu.visible$ === undefined || (menu.visible$ | async))) {
          @let badge = badgeView(menu) | async;
          @if (menu.dropdown) {
            <button mat-menu-item [matMenuTriggerFor]="popup">
              <span class="adx-dropdown-item-row">
                <span>
                  @if (menu.icon) {
                    <fa-icon class="adx-menu-icon" [icon]="menu.icon"></fa-icon>
                  }
                  @if (menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName +
                          "." +
                          menu.pluginModule +
                          "." +
                          menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                  @if (!menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName + "." + menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                  <ng-container *ngTemplateOutlet="badgeStatus; context: { $implicit: badge }"></ng-container>
                </span>
                <ng-container *ngTemplateOutlet="itemBadge; context: { $implicit: badge }"></ng-container>
              </span>
            </button>
            <!-- second level nested Menu-->
            <mat-menu #popup="matMenu">
              @for (item of menu.dropdownItems; track item.nameIdentifier) {
                @if (item.customPanel === 'dashboard-select') {
                  <lib-dashboard-select-menu [showSeparator]="hasDropdownActionsBelowPanel(menu)"></lib-dashboard-select-menu>
                } @else if (canAccessDropdownMenu(menu, item) && (item.visible$ | async) !== false) {
                  <button
                    mat-menu-item
                    (click)="triggerMenuCallback(item, index, menu)"
                    [disabled]="item.disabled | async"
                  >
                    <ng-container *ngTemplateOutlet="dropdownItemLabel; context: { $implicit: item }"></ng-container>
                  </button>
                }
              }
            </mat-menu>
          } @else {
            <button
              mat-menu-item
              (click)="triggerMenuCallback(menu, index)"
              [disabled]="menu.disabled | async"
            >
              @if (getAltIcon(menu)) {
                @if (menu.altIcon) {
                  <fa-icon
                    class="adx-menu-icon"
                    [icon]="menu.altIcon"
                  ></fa-icon>
                }
                @if (menu.altName) {
                  <span>
                    {{
                      menu.pluginName +
                        "." +
                        menu.pluginModule +
                        "." +
                        menu.altName | translate
                    }}
                  </span>
                } @else {
                  @if (menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName +
                          "." +
                          menu.pluginModule +
                          "." +
                          menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                  @if (!menu.pluginModule) {
                    <span>
                      {{
                        menu.pluginName + "." + menu.nameIdentifier | translate
                      }}
                    </span>
                  }
                }
              } @else {
                @if (menu.iconLayers) {
                  <fa-layers class="adx-menu-icon">
                    @for (layer of menu.iconLayers; track layer) {
                      <fa-icon
                        [icon]="layer.icon"
                        [transform]="layer.transform ?? ''"
                      >
                      </fa-icon>
                    }
                  </fa-layers>
                } @else {
                  @if (menu.icon) {
                    <fa-icon class="adx-menu-icon" [icon]="menu.icon"></fa-icon>
                  }
                }
                @if (menu.pluginModule) {
                  <span>
                    {{
                      menu.pluginName +
                        "." +
                        menu.pluginModule +
                        "." +
                        menu.nameIdentifier | translate
                    }}
                  </span>
                }
                @if (!menu.pluginModule) {
                  <span>
                    {{
                      menu.pluginName + "." + menu.nameIdentifier | translate
                    }}
                  </span>
                }
              }
            </button>
          }
        }
      }
      <button mat-menu-item (click)="logout.callback()">
        <fa-icon class="adx-menu-icon" [icon]="logout.icon"></fa-icon>
        <span>{{ logout.name }}</span>
      </button>
    </mat-menu>
  </mat-toolbar>
}
